import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useInView } from 'react-intersection-observer'

import ComponentTitle from '../../../components/ComponentTitle/ComponentTitle'
import CaseStudiesMobile from '../CaseStudiesMobile/CaseStudiesMobile'
import useWindowDimension from '../../../hooks/useWindowDimension'

import PrimaryColorChange from '../../../resources/images/transformedToSvg/primary-color-change-anim.svg'
import ChangeTextColor from '../../../resources/images/transformedToSvg/change-text-color-anim.svg'
import UploadLogoAnim from '../../../resources/images/transformedToSvg/upload-logo-anim.svg'

import {
	StyledContainer,
	StyledTitleContainer,
	StyledMainContainer,
	StyledInnerContainer,
	StyledInnerSideBar,
	StyledLi,
	StyledInnerImageContainer,
	StyledHeaderDescription
} from './VerificationFlowStyle'

const images = {
	primaryColorChange: <PrimaryColorChange />,
	uploadLogo: <UploadLogoAnim />,
	textColorChange: <ChangeTextColor />
}

const VerificationFlow = () => {
	const { ref, inView } = useInView({ triggerOnce: true })

	const { t } = useTranslation()
	const [active, setActive] = useState('primaryColorChange')
	const [animation, setAnimation] = useState(false)
	const [isClick, setIsClick] = useState(false)
	const timer = useRef()

	useEffect(() => {
		if (!isClick && inView) {
			if (active === 'primaryColorChange') {
				setTimeout(() => {
					setActive('uploadLogo')
				}, 6500)
			} else if (active === 'uploadLogo') {
				setTimeout(() => {
					setActive('textColorChange')
				}, 8500)
			}
		}
	}, [active, isClick, inView])

	const onActiveChange = title => {
		if (title === active) {
			setActive('primaryColorChange')
		} else {
			setActive(title)
		}
	}

	const handleAnimationChange = () => {
		if (animation) {
			clearTimeout(timer.current)
			timer.current = setTimeout(() => setAnimation(state => !state), 300)
			setAnimation(false)
			setAnimation(true)
		} else {
			timer.current = setTimeout(() => setAnimation(state => !state), 300)
			setAnimation(true)
		}
	}

	const showHideAnimation = title => {
		onActiveChange(title)
		handleAnimationChange()
		setIsClick(true)
	}
	const { windowSize } = useWindowDimension()
	return (
		<>
			{windowSize.width > 960 && (
				<StyledContainer ref={ref} id={`verificationFlow`}>
					<StyledMainContainer>
						<StyledTitleContainer>
							<ComponentTitle value='CustomizeVerificationFlow' />
						</StyledTitleContainer>
						<StyledInnerSideBar>
							<StyledLi
								active={active === 'primaryColorChange'}
								onClick={() => showHideAnimation('primaryColorChange')}
							>
								{t('primaryColorChange')}
							</StyledLi>
							<StyledLi active={active === 'uploadLogo'} onClick={() => showHideAnimation('uploadLogo')}>
								{t('uploadLogo')}
							</StyledLi>
							<StyledLi active={active === 'textColorChange'} onClick={() => showHideAnimation('textColorChange')}>
								{t('textColorChange')}
							</StyledLi>
						</StyledInnerSideBar>
						<StyledHeaderDescription>{t('verificationFlowDesc')}</StyledHeaderDescription>
						<StyledInnerContainer>
							<StyledInnerImageContainer animation={animation}>{images[active]}</StyledInnerImageContainer>
						</StyledInnerContainer>
					</StyledMainContainer>
				</StyledContainer>
			)}
			{windowSize.width < 960 && <CaseStudiesMobile />}
		</>
	)
}

export default VerificationFlow
